import Layout from "@components/layout"
import ProjectGalleryByCategories from "@components/pages/project-gallery/project-gallery-by-category"
import SEO from "@components/seo"
import { F_Q_GALLERY_CATEGORIES, F_Q_GALLERY_CATEGORY } from "lib/function"
import { Helmet } from "react-helmet"

export default function ProjectGalleryCategoryPage({ data, locale }) {
  return (
    <>
      <SEO
        title={locale === "en" ? "Project Gallery & Events" : "Proyek & Event"}
      />
      <Helmet>
        <body className="bd-project-gallery-category" />
      </Helmet>
      <Layout>
        <ProjectGalleryByCategories
          list={data?.galleries}
          title={data?.title}
          slug={`${data?.slug}-${data?.id}`}
        />
      </Layout>
    </>
  )
}

export async function getStaticPaths() {
  const token = process.env.INIT_TOKEN
  // Fetch list of all galleries to generate paths
  const response = await F_Q_GALLERY_CATEGORIES({ lang: "en" }, token)
  const categories = response?.data?.galleryCategories || []

  // Get the paths we want to pre-render
  const pathsId = categories.map((item) => ({
    params: { categoryslug: `${item.slug}-${item.id}` },
    locale: "id",
  }))
  const pathsEn = categories.map((item) => ({
    params: { categoryslug: `${item.slug}-${item.id}` },
    locale: "en",
  }))
  // fallback: true means pages that are not built at build time will not result in a 404
  return { paths: [...pathsEn, ...pathsId], fallback: true }
}

export const getStaticProps = async (ctx) => {
  let token = process.env.INIT_TOKEN
  let { locale, params } = ctx
  let slugParts = params.categoryslug.split("-")
  let id = slugParts[slugParts.length - 1]
  let data = await F_Q_GALLERY_CATEGORY({ language: locale, id }, token)
  return {
    props: {
      locale,
      data: data?.data?.galleryCategory ?? null,
      token,
    },
    revalidate: 60,
  }
}
